import { Table } from "semantic-ui-react";
import type Contact from "../../../../interfaces/contact";
import { MultipleItems, TextTruncate } from "../../../../components";
import MinusButton from "../../../../components/buttons/iconButtons/minusButton/MinusButton";
import { Tooltip } from "../../../../components/common/tooltip";
import UserInfoCell from "../../../../components/userInfoCell/UserInfoCell";
import columnOptions from "./columnOptions";
import styles from "./ManagedByContacts.module.scss";

export type ManagedByContactRowProps = {
  contact: Contact;
  isReadOnly: boolean;
  onContactRemoved: (contactId: number) => void;
  accountId: number;
  moboAccountId: number;
};

function ManagedByContactRow(props: ManagedByContactRowProps) {
  const { contact, isReadOnly, accountId, moboAccountId, onContactRemoved } = props;

  const renderRemoveButton = (c: Contact) => (
    <Table.Cell className={styles["align-right-contacts"]} width={columnOptions[4].width}>
      <Tooltip
        position="top center"
        hideOnScroll
        showAlways
        target={<MinusButton onClick={() => onContactRemoved(c.id)} isDisabled={isReadOnly} />}
        content="Remove"
      />
    </Table.Cell>
  );

  return (
    <>
      <Table.Cell width={columnOptions[0].width}>
        <UserInfoCell
          moboAccountId={moboAccountId !== accountId ? moboAccountId : undefined}
          target={moboAccountId !== accountId ? "_blank" : undefined}
          deepLink
          user={contact}
        />
      </Table.Cell>
      <Table.Cell width={columnOptions[1].width}>
        <Tooltip target={<TextTruncate>{contact.department}</TextTruncate>} content={contact.department} />
      </Table.Cell>
      <Table.Cell width={columnOptions[2].width}>
        <Tooltip target={<TextTruncate>{contact.title}</TextTruncate>} content={contact.title} />
      </Table.Cell>
      <Table.Cell width={columnOptions[3].width}>
        <MultipleItems items={contact.roles.map((role: { name: string }) => role.name)} />
      </Table.Cell>
      {renderRemoveButton(contact)}
    </>
  );
}

export default ManagedByContactRow;
